import type { AddFieldCommandOptions } from '@cli-types/core-engine/commands.js'

export function hasNonInteractiveFieldOptions(options: AddFieldCommandOptions): boolean {
  return Boolean(
    options.type ||
    options.field ||
    options.label ||
    options.slot ||
    options.step ||
    options.before ||
    options.after ||
    options.required ||
    options.multiple ||
    options.creatable ||
    options.relationship ||
    (options.option && options.option.length > 0)
  )
}
